export const minDate = '1960-01-01';
export const CURRENT_PLACEHOLDER_DATE = '9999-12-31';
export const maxDate = new Date().toISOString().split('T')[0];

/* only 18 years old can create account */
// today
const today = new Date();

// person must be at least 18 years old
const maxAllowedDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

// optional: minimum DOB allowed (e.g., nobody older than 100 years)
const minAllowedDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());

// format to YYYY-MM-DD (HTML date input format)
const formatDate = (date: Date) => date.toISOString().split('T')[0];
export const minBirthDate = formatDate(minAllowedDate);
export const maxBirthDate = formatDate(maxAllowedDate);
